export default ['not_authenticated', 'authentication_failed', 'login_failed']